import store from '../store'
import Welcome from '../views/Welcome.vue'
import Home from '../views/Home.vue'
import PageNotFound from '../views/PageNotFound.vue'
const routes = [
    {
        path: '/',
        component: Welcome,
        meta: { auth: false },
        children: [
            {
                path: '/',
                name: 'Welcome',
                component: () => import(/* webpackChunkName: "welcome" */ '../views/WelcomePage.vue'),
                meta: { auth: false }
            },
            {
                path: 'register/:token(\\w{80})',
                name: 'Register',
                component: () => import(/* webpackChunkName: "welcome" */ '../views/auth/Register.vue'),
                meta: { auth: false }
            },
            {
                path: 'login',
                name: 'Login',
                component: () => import(/* webpackChunkName: "welcome" */ '../views/auth/Login.vue'),
                meta: { auth: false }
            },
            {
                path: 'password/reset',
                name: 'Password Reset',
                component: () => import(/* webpackChunkName: "welcome" */ '../views/auth/PasswordResetForm.vue'),
                meta: { auth: false }
            },
            {
                path: 'password/reset/:token',
                name: 'Password Update',
                component: () => import(/* webpackChunkName: "welcome" */ '../views/auth/PasswordUpdateForm.vue'),
                meta: { auth: false }
            },
            {
                path: 'support',
                name: 'Welcome Support',
                component: () => import(/* webpackChunkName: "welcome" */ '../components/SupportContact.vue'),
                meta: { auth: false }
            }
        ],
        beforeEnter: (to, from, next) => {
            if (from.name == null) {
                store.dispatch('auth/fetchUser').then(() => {
                    next({ name: 'Home' })
                }).catch(() => {
                    next()
                })
            } else {
                next()
            }
        }
    },
    {
        path: '/home',
        component: Home,
        meta: { auth: true },
        children: [
            {
                path: 'user',
                name: 'User',
                component: () => import(/* webpackChunkName: "home" */ '../views/home/User.vue'),
                meta: { auth: true }
            },
            {
                path: 'password',
                name: 'PasswordUpdate',
                component: () => import(/* webpackChunkName: "home" */ '../views/home/PasswordUpdate.vue'),
                meta: { auth: true }
            },
            {
                path: 'customization',
                name: 'Customization',
                component: () => import(/* webpackChunkName: "admin" */ '../views/resellers/Customization.vue'),
                meta: { auth: true, admin: true }
            },
            {
                path: 'entities',
                name: 'Resellers Entities',
                component: () => import(/* webpackChunkName: "admin" */ '../views/resellers/Entities.vue'),
                meta: { auth: true, admin: true }
            },
            {
                path: 'users',
                name: 'Resellers Users',
                component: () => import(/* webpackChunkName: "admin" */ '../views/resellers/Users.vue'),
                meta: { auth: true, admin: true }
            },
            {
                path: 'applications',
                name: 'Applications',
                component: () => import(/* webpackChunkName: "home" */ '../views/users/Applications.vue'),
                meta: { auth: true }
            },
            {
                path: 'clients',
                name: 'Clients',
                component: () => import(/* webpackChunkName: "home" */ '../views/users/Clients.vue'),
                meta: { auth: true }
            },
            {
                path: 'devices',
                name: 'Devices',
                component: () => import( /* webpackChunkName: "home" */ '../views/users/Devices.vue'),
                meta: { auth: true }
            },
            {
                path: 'licences',
                name: 'Licences',
                component: () => import(/* webpackChunkName: "home" */ '../views/users/Licences.vue'),
                meta: { auth: true }
            },
            {
                path: '/',
                name: 'Home',
                component: () => import(/* webpackChunkName: "home" */ '../views/Accueil.vue'),
                meta: { auth: true }
            },
            {
                path: 'compteurs',
                name: 'Compteurs',
                component: () => import(/* webpackChunkName: "home" */ '../views/users/Compteurs.vue'),
                meta: { auth: true }
            },
            {
                path: 'support',
                name: 'Support',
                component: () => import(/* webpackChunkName: "welcome" */ '../components/SupportContact.vue'),
                meta: { auth: true }
            },
            {
                path: 'documentation',
                name: 'Documentation',
                component: () => import(/* webpackChunkName: "home"*/ '../views/Documentation.vue'),
                meta: { auth: true },
                children: [
                    {
                        path: 'homeDoc',
                        name: 'DocAccueil',
                        component: () => import(/* webpackChunkName: "documentation" */ '../views/documentation/DocAccueil.vue'),
                        meta: { auth: true }
                    },
                    {
                        path: 'profilDoc',
                        name: 'DocProfil',
                        component: () => import(/* webpackChunkName: "documentation" */ '../views/documentation/DocProfil.vue'),
                        meta: { auth: true }
                    },
                    {
                        path: 'clientsDoc',
                        name: 'DocClients',
                        component: () => import(/* webpackChunkName: "documentation" */ '../views/documentation/DocClients.vue'),
                        meta: { auth: true }
                    },
                    {
                        path: 'countersDoc',
                        name: 'DocCounters',
                        component: () => import(/* webpackChunkName: "documentation" */ '../views/documentation/DocCounters.vue'),
                        meta: { auth: true }
                    },
                    {
                        path: 'devicesDoc',
                        name: 'DocDevices',
                        component: () => import(/* webpackChunkName: "documentation" */ '../views/documentation/DocDevices.vue'),
                        meta: { auth: true }
                    },
                    {
                        path: 'licencesDoc',
                        name: 'DocLicences',
                        component: () => import(/* webpackChunkName: "documentation" */ '../views/documentation/DocLicences.vue'),
                        meta: { auth: true }
                    },
                    {
                        path: 'entitiesDoc',
                        name: 'DocEntities',
                        component: () => import(/* webpackChunkName: "documentation" */ '../views/documentation/DocEntities.vue'),
                        meta: { auth: true }
                    },
                    {
                        path: 'usersDoc',
                        name: 'DocUsers',
                        component: () => import(/* webpackChunkName: "documentation" */ '../views/documentation/DocUsers.vue'),
                        meta: { auth: true }
                    }
                ],
            },
            {
                path: 'inactive',
                name: 'Inactive Reseller',
                component: () => import(/* webpackChunkName: "home" */ '../views/InactiveReseller.vue'),
                meta: { auth: true },
                beforeEnter (from, to, next) {
                    if (store.state.auth.user.reseller_active) {
                        next({ name: 'Home' })
                    } else {
                        next()
                    }
                }
            }
        ]
    },
    {
        path: '/auth/:provider/callback',
        component: {
            template: '<div class="auth-component"></div>'
        }
    },
    {
        path: '*',
        name: 'Page404',
        component: PageNotFound,
    }
]

export default routes;